import {useQuery, useMutation} from 'admin/lib/apollo'
import {useQueryParams, StringParam, NumberParam, withDefault} from 'use-query-params'
import {GET_STATEMENT, SEND_STATEMENT_EMAIL} from 'admin/gql/Statement.gql'
import useEffect from 'admin/hooks/useEffect'
import useAdmin from './useAdmin'

export default (organisationId, accountId) => {
  const {admin} = useAdmin()
  const [filters, setFilters] = useQueryParams({
    fromDate: StringParam,
    toDate: StringParam,
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 50),
    sortDirection: withDefault(StringParam, 'desc')
  })

  useEffect(() => {
    if (admin.preferences?.transactionsDefaultOrder) {
      setFilters({sortDirection: admin.preferences.transactionsDefaultOrder})
    }
  }, [admin.preferences])

  const variables = {organisationId, accountId, ...filters}

  const {data: {statement = {}} = {}, error: getError} = useQuery(GET_STATEMENT, {variables})

  const [send, {error: sendError}] = useMutation(SEND_STATEMENT_EMAIL, {
    variables,
    flash: 'Statement email submitted'
  })

  return {
    filters,
    setFilters,
    statement: statement.collection || [],
    errors: getError || sendError || {},
    totalCount: statement.metadata ? statement.metadata.totalCount : 0,
    send
  }
}
